// FFD APIの共通クライアント
export const getFfdUrl = (path: string) => {
  const baseUrl = process.env.REACT_APP_ENDPOINT_URL ?? "";
  return `${baseUrl}${path}`;
};

// 認証エラー時の共通メッセージ
export const alertAuthExpired = () => {
  alert("The authorization key may have expired.\nPlease store the necessary data and reload the page.");
};

// Authorization付きでJSONを取得する
export const fetchFfdJson = async <T>(
  path: string,
  authToken: string,
  init: RequestInit = {}
): Promise<{ response: Response; data: T }> => {
  const response = await fetch(getFfdUrl(path), {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: authToken,
      ...(init.headers ?? {}),
    },
  });

  const data = (await response.json().catch(() => ({}))) as T;
  return { response, data };
};
